const addWishlistItem = document.querySelectorAll('.krokedil-wishlist');
if (addWishlistItem) {
	addWishlistItem.forEach((item) => {
		item.addEventListener('click', (itemClick) => {
			itemClick.preventDefault();
			item.classList.add('loading');
			const formData = new FormData();
			const path = document.querySelector(
				'[data-post-id="' + item.dataset.postId + '"] svg path'
			);
			if (path.classList.contains('krokedil-icon-added')) {
				if (!krokedil_wishlist_translation.logged_in) {
					formData.append(
						'wc-nonce',
						krokedil_wishlist_translation.delete_guest_item_cookie_nonce
					);

					const currentUrl = window.location.href;

					if (currentUrl.includes('/product/')) {
						if (window.localStorage.getItem('varId') === '0') {
							formData.append('post_id', item.dataset.postId);
						} else {
							formData.append(
								'post_id',
								window.localStorage.getItem('varId')
							);
						}
					} else {
						formData.append('post_id', item.dataset.postId);
					}
					path.classList.remove('krokedil-icon-added');
					path.classList.add('krokedil-icon');
					send(
						formData,
						krokedil_wishlist_translation.delete_guest_item_from_cookie
					);
				} else {
					formData.append(
						'wc-nonce',
						krokedil_wishlist_translation.delete_wishlist_item_nonce
					);
					formData.append(
						'usr_id',
						krokedil_wishlist_translation.current_user_id
					);
					const variationId = document.querySelector('.variation_id');

					if (window.location.href.includes('product')) {
						if (variationId === null) {
							formData.append('post_id', item.dataset.postId);
						} else if (
							window.location.href.includes('product') &&
							parseInt(variationId.value) > 0
						) {
							formData.append(
								'post_id',
								window.localStorage.getItem('varId')
							);
						}
					} else {
						formData.append('post_id', item.dataset.postId);
					}
					// console.log(item.childNodes[1].childNodes[1]);
					// item.childNodes[1].childNodes[1].classList.remove(
					// 	'krokedil-icon-added'
					// );
					// item.childNodes[1].childNodes[1].classList.add(
					// 	'krokedil-icon'
					// );
					path.classList.remove('krokedil-icon-added');
					path.classList.add('krokedil-icon');
					send(
						formData,
						krokedil_wishlist_translation.delete_wishlist_item_action
					);
				}
			} else {
				const currentUrl = window.location.href;
				const variationId = document.querySelector('.variation_id');
				if (
					!currentUrl.endsWith('shop') &&
					currentUrl.includes('/product/') &&
					variationId
				) {
					if (variationId.value === '0') {
						alert(
							'Please select some product options before adding this product to your cart.'
						);
						itemClick.preventDefault();
						return false;
					}
					formData.append(
						'post_id',
						document.querySelector('.variation_id').value
					);

					if (
						parseInt(variationId.value) ===
						parseInt(window.localStorage.getItem('varId'))
					) {
						window.localStorage.setItem(
							'varId',
							window.localStorage.getItem('varId')
						);
					} else {
						window.localStorage.setItem(
							'varId',
							document.querySelector('.variation_id').value
						);
					}
				} else {
					formData.append('post_id', item.dataset.postId);
				}
				formData.append(
					'wc_nonce',
					krokedil_wishlist_translation.add_to_default_wishlist_nonce
				);
				// item.childNodes[1].childNodes[1].classList.remove(
				// 	'krokedil-icon'
				// );
				// item.childNodes[1].childNodes[1].classList.add(
				// 	'krokedil-icon-added'
				// );
				path.classList.remove('krokedil-icon');
				path.classList.add('krokedil-icon-added');
				send(
					formData,
					krokedil_wishlist_translation.add_to_default_wishlist_action
				);
			}
		});
	});
}

jQuery(document).on('krokedil-wishlist-update', function(e) {
	e.preventDefault();
	const data = {
		action: 'krokedil_favorites_get_amount',
	};

	jQuery.post(krokedil_wishlist_translation.ajaxurl, data, function(
		response
	) {
		if (response === 0) {
			jQuery('body').removeClass('have-favorites');
			jQuery('.quicklinks-wrapper ul li.icon').removeClass('with-number');
		} else if (!jQuery('body').hasClass('have-favorites')) {
			jQuery('body').addClass('have-favorites');
			jQuery('.quicklinks-wrapper ul li.icon').addClass('with-number');
		}
		jQuery('.quicklinks-wrapper ul li.icon .number').text(response);
	});
});

const krokedilFirstLetterUppercase = (string) =>
	string.charAt(0).toUpperCase() + string.slice(1);
const krokedilFirstLetterLowercase = (string) =>
	string.charAt(0).toLowerCase() + string.slice(1);

const resolveSuccess = (res) => {
	const _response = JSON.parse(res);
	if (_response.data.action === 'del_wish_item') {
		const del = document.querySelector(
			'[data-post-id="' + _response.data.pid + '"] .delete-wishlist-item'
		);
		del.parentElement.remove();
		//	Clear cookies
		document.cookie = 'krokedil-favorites=; path=/;';
	} else if (
		_response.data.action === 'uhi' &&
		_response.data.message === '0'
	) {
		const wrapper = document.querySelector('.woocommerce-notices-wrapper');
		const paragraph = document.createElement('p');
		paragraph.append(
			document.createTextNode(krokedil_wishlist_translation.wl_no_items)
		);
		wrapper.append(paragraph);
	} else if (
		_response.data.action === 'var_pro' &&
		typeof _response.data.variations !== 'undefined' &&
		_response.data.variations !== null &&
		_response.data.variations.length !== null &&
		_response.data.variations.length > 0
	) {
		showProductVarsInModal(_response.data);
	} else if (_response.data.action === 'product_refresh') {
		refreshProduct(_response);
	} else if (_response.data.message === 'deleted' && _response.data.pid) {
		const del = document.querySelector(
			'[data-post-id="' + _response.data.pid + '"] .delete-wishlist-item'
		);
		if (_response.data.wishlist_id) {
			userHaveItems(_response.data.wishlist_id);
		}
		del.parentElement.remove();
	} else if (_response.data.message === 'deleted' && _response.data.pid) {
		const del = document.querySelector(
			'[data-post-id="' + _response.data.pid + '"] .delete-wishlist-item'
		);
		if (_response.data.wishlist_id) {
			userHaveItems(_response.data.wishlist_id);
		}
		del.parentElement.remove();
	} else {
		throw new Error('Something went wrong');
	}
};

/**
 *
 *
 * @param {*} data
 * @param {*} url
 */
const send = (data, url) =>
	window.fetch ? sendDataByFetch(data, url) : sendDataByXMLReq(data, url);

/**
 *
 * @param {*} data
 * @param {*} url
 */
const sendDataByFetch = (data, url) => {
	fetch(url, {
		method: 'POST',
		body: data,
	})
		.then(handleErrors)
		.then(handleSuccess)
		.catch(() => new Error('Something went wrong'));
};

/**
 *
 * @param {*} data
 * @param {*} url
 */
const sendDataByXMLReq = (data, url) => {
	const xmlHttpRequest = new XMLHttpRequest();
	xmlHttpRequest.open('POST', url, true);
	xmlHttpRequest.onload = () => resolveSuccess(xmlHttpRequest.responseText);
	xmlHttpRequest.onerror = () => new Error('Something went wrong');
	xmlHttpRequest.send(data);
};

const handleSuccess = (response) => response.text().then(resolveSuccess);
/**
 *
 * @param {*} response
 */
const handleErrors = (response) => {
	if (!response.ok) {
		throw Error(response.statusText);
	}
	return response;
};

/**
 *
 * @param {*} modal
 */
const closeModal = (modal) => {
	if (modal) {
		modal.style.display = 'none';
		document.getElementsByTagName('body')[0].classList.remove('modal-open');
	}
};

const deleteWishlistItems = document.querySelectorAll(
	'.delete-wishlist-item a'
);
if (deleteWishlistItems) {
	deleteWishlistItems.forEach((item) => {
		item.addEventListener('click', (dwiEvent) => {
			dwiEvent.preventDefault();
			if (
				window.confirm(
					'Are you sure you want to delete the product from the wishlist'
				)
			) {
				const formData = new FormData();
				if (
					parseInt(krokedil_wishlist_translation.current_user_id) <= 0
				) {
					formData.append(
						'wc-nonce',
						krokedil_wishlist_translation.delete_guest_item_cookie_nonce
					);
					formData.append('wishlist_id', item.dataset.wishlistId);
					formData.append('post_id', item.dataset.postId);
					send(
						formData,
						krokedil_wishlist_translation.delete_guest_item_from_cookie
					);
				} else {
					formData.append(
						'wc-nonce',
						krokedil_wishlist_translation.delete_wishlist_item_nonce
					);
					formData.append('wishlist_id', item.dataset.wishlistId);
					if (window.location.href.includes('/product/')) {
						window.localStorage.getItem('varId');
						formData.append('post_id', item.dataset.postId);
						window.localStorage.setItem('varId', 0);
					} else {
						formData.append('post_id', item.dataset.postId);
					}
					send(
						formData,
						krokedil_wishlist_translation.delete_wishlist_item_action
					);
				}
				userHaveItems(item.dataset.wishlistId);
			}
		});
	});
}
// Get the Red, Green and Blue integer values of a color
const shadeColor = (color) => {
	let R = parseInt(color.substring(1, 3), 16);
	let G = parseInt(color.substring(3, 5), 16);
	let B = parseInt(color.substring(5, 7), 16);
	R = parseInt(R);
	G = parseInt(G);
	B = parseInt(B);

	// 255 is white, 0 is black - the thresholds have been changed to avoid full white/black fills
	R = R < 253 ? R : 254;
	G = G < 253 ? G : 254;
	B = B < 253 ? B : 254;
	R = R > 3 ? R : 1;
	G = G > 3 ? G : 1;
	B = B > 3 ? B : 1;

	return [R, G, B];
};

// If the color crosses a certain threshold and becomes too dark or too bright, apply constant text colors
const textThresholdColor = (color, targetObjectText) => {
	let R = parseInt(color.substring(1, 3), 16);
	let G = parseInt(color.substring(3, 5), 16);
	let B = parseInt(color.substring(5, 7), 16);
	R = parseInt(R);
	G = parseInt(G);
	B = parseInt(B);

	// 255 is white, 0 is black - the thresholds have been changed to avoid full white/black fills
	R = R < 253 ? R : 254;
	G = G < 253 ? G : 254;
	B = B < 253 ? B : 254;
	R = R > 3 ? R : 1;
	G = G > 3 ? G : 1;
	B = B > 3 ? B : 1;

	if (R > 220 || G > 220 || B > 220) {
		targetObjectText.style.color = 'black';
	} else if (R < 30 || G < 30 || B < 30) {
		targetObjectText.style.color = 'white';
	}
};

const userHaveItems = () => {
	const formData = new FormData();
	formData.append(
		'wc-nonce',
		krokedil_wishlist_translation.user_have_items_nonce
	);
	send(formData, krokedil_wishlist_translation.user_have_items_action);
};

const variableProducts = document.querySelectorAll('.product_type_variable');
variableProducts.forEach((variableProduct) => {
	variableProduct.onclick = (click) => {
		click.preventDefault();
		const currentUrl = window.location.href;

		if (!currentUrl.endsWith('/shop/')) {
			const productId = variableProduct.dataset.product_id;
			const data = new FormData();
			data.append('pid', productId);
			data.append(
				'wc_nonce',
				krokedil_wishlist_translation.get_product_variation_nonce
			);
			send(
				data,
				krokedil_wishlist_translation.get_product_variation_action
			);
		} else if (!currentUrl.includes('my-account')) {
			window.location = variableProduct.href;
		}
	};
});

const refreshProduct = (response) => {
	const post = document.querySelector(
		'[data-post-id="' + response.data.pid + '"]'
	);
	const productImage = document.querySelector(
		'[data-post-id="' + response.data.pid + '"] .item-image'
	);
	const productSku = document.querySelector(
		'[data-post-id="' + response.data.pid + '"] .item-actions-and-price'
	);
	const deleteProduct = document.querySelector(
		'[data-post-id="' + response.data.pid + '"] .delete-wishlist-item'
	);
	const productTitle = document.querySelector(
		'[data-post-id="' + response.data.pid + '"] .product-link'
	);
	const productDelete = document.querySelector(
		'[data-post-id="' + response.data.pid + '"] .delete-wishlist-item > a'
	);
	productImage.innerHTML = '';
	productImage.innerHTML = response.data.image;
	productSku.innerHTML = '';
	productSku.innerHTML = response.data.sku;
	deleteProduct.dataset.postId = response.data.id;
	productDelete.dataset.postId = response.data.id;
	productTitle.innerHTML = response.data.name;
	post.dataset.postId = response.data.id;
};
const winClosed = (modal) => {
	window.onclick = (event) => {
		if (event.target === modal) {
			closeModal(modal);
		}
	};
};

const showProductVarsInModal = (dataVariations) => {
	// create div, main element for modal window
	const krokedilModalWrapper = document.createElement('div');
	krokedilModalWrapper.style.display = 'flex';

	// add some style to our div, class, id etc
	krokedilModalWrapper.id = 'product-krokedil-wc-variation';
	// iterate for each css class and add it to our div.
	['modal', 'krokedil-wish-list-modal'].forEach((className) =>
		krokedilModalWrapper.classList.add(className)
	);
	const krokedilModalContent = document.createElement('div');
	// add style
	krokedilModalContent.classList.add('modal-content');

	// create title and close button holder
	const krokedilTitleHolder = document.createElement('div');
	//add title holder style
	krokedilTitleHolder.classList.add('krokedil-view-options-title-holder');

	// create span element
	const krokedilSpan = document.createElement('span');
	krokedilSpan.classList.add('close'); // add css
	krokedilSpan.classList.add('dashicons');
	krokedilSpan.classList.add('dashicons-no-alt');

	// add listener to close modal
	krokedilSpan.onclick = () => closeModal(krokedilModalWrapper);
	// add span to modal content
	krokedilModalContent.append(krokedilSpan);
	// create paragraph element
	const krokedilModalTitle = document.createElement('p');
	// set modal title
	krokedilModalTitle.innerHTML = 'Choose Product Variation';
	krokedilModalTitle.classList.add(
		'krokedil-view-options-title-holder-title-text'
	);
	// add title and span to title holder
	krokedilTitleHolder.append(krokedilModalTitle); // add modal title
	krokedilTitleHolder.append(krokedilSpan); // add close btn
	// add title holder to modal window
	krokedilModalContent.append(krokedilTitleHolder);
	krokedilModalWrapper.append(krokedilModalContent); // add modal content
	const form = document.createElement('form'); // create form tag
	form.id = 'choose-product-variation-form';
	const dropdownLists = createSelectsDropdownList(dataVariations, form);
	const dropDownListsClone = {};
	for (const key in dropdownLists) {
		dropDownListsClone[key] = dropdownLists[key].cloneNode(true);
	}
	let labelIndex = 0;
	const labels = dataVariations.labels;
	for (const key in dropdownLists) {
		const label = document.createElement('label');
		label.htmlFor = krokedilFirstLetterLowercase(key);
		label.innerHTML = labels[labelIndex++];
		form.append(label);
		form.append(dropdownLists[key]);
	}
	const add2Wishlist = document.createElement('button');
	add2Wishlist.type = 'submit';
	add2Wishlist.innerHTML = 'Add to the wishlist';
	add2Wishlist.id = 'add-to-wishlist-submit';

	// Get custom color custom colors
	const clearOptionsNewColor = dataVariations.custom_color;
	const clearOptionsNewRedColor = shadeColor(clearOptionsNewColor)[0];
	const clearOptionsNewGreenColor = shadeColor(clearOptionsNewColor)[1];
	const clearOptionsNewBlueColor = shadeColor(clearOptionsNewColor)[2];

	// Create 'Clear' button
	const clearOption = document.createElement('a');
	clearOption.id = 'clear-option';
	clearOption.classList.add('reset_variations');
	clearOption.innerHTML = 'Clear';
	clearOption.cursor = 'pointer';
	clearOption.onclick = () => {
		for (const prop in dropdownLists) {
			document.getElementById(prop).innerHTML =
				dropDownListsClone[prop].innerHTML;
		}
	};

	// Add custom color color to the 'Clear' button in Wishlist view Product Variations' pop-up window
	if (clearOption) {
		clearOption.style.backgroundColor = clearOptionsNewColor;

		textThresholdColor(clearOptionsNewColor, clearOption);
		clearOption.addEventListener('mouseover', (event) => {
			event.preventDefault();
			clearOption.style.backgroundColor =
				'rgb(' +
				String(clearOptionsNewRedColor) +
				',' +
				String(clearOptionsNewGreenColor) +
				',' +
				String(clearOptionsNewBlueColor) +
				',0.5)';
		});
		clearOption.addEventListener('mouseout', (event) => {
			event.preventDefault();
			clearOption.style.backgroundColor =
				'rgb(' +
				String(clearOptionsNewRedColor) +
				',' +
				String(clearOptionsNewGreenColor) +
				',' +
				String(clearOptionsNewBlueColor) +
				',1)';
		});
	}

	form.append(add2Wishlist);
	form.append(clearOption);
	form.addEventListener('submit', (subEvent) => {
		subEvent.preventDefault();
		const formData = new FormData(form);
		formData.append(
			'wc-nonce',
			krokedil_wishlist_translation.add_to_wishlist_nonce
		);
		if (!krokedil_wishlist_translation.logged_in) {
			formData.append('list_gid', 1);
		}
		formData.append('post_id', dataVariations.pid);
		formData.append('default', 1);
		send(formData, krokedil_wishlist_translation.add_to_wishlist_action);
		closeModal(krokedilModalWrapper);
	});
	krokedilModalContent.append(form);
	document.getElementsByTagName('body')[0].classList.add('modal-open');
	document.getElementsByTagName('body')[0].append(krokedilModalWrapper);
	winClosed(krokedilModalWrapper);
};

/**
 * woocommerce attributes
 *
 * @param {*} variationAttributes
 * @param {*} form
 */
const createSelectsDropdownList = (variationAttributes, form) => {
	const dropdownHolders = {};
	const names = variationAttributes.names;
	let nameIndex = 0;
	for (const key in variationAttributes.prod_attributes) {
		if (variationAttributes.prod_attributes.hasOwnProperty(key)) {
			const dropdown = document.createElement('select');
			dropdown.id = krokedilFirstLetterLowercase(key);
			dropdown.onchange = (dropdownEvent) => {
				if (!form) {
					return;
				}
				const formSelects = form.querySelectorAll('select');
				if (!formSelects) {
					return;
				}
				const selectedValue = dropdownEvent.target.value;
				const selectedId = dropdownEvent.target.id;
				const existingAttributes =
					variationAttributes.existing_attributes;
				const reorderedAttributes = reorder(
					existingAttributes,
					selectedId
				);
				const items = reorderedAttributes[selectedValue];
				const isDefaultOption = (value) => value === 'Choose an option';
				const isNotDefaultOption = (value) => !isDefaultOption(value);
				const otherSelects = (select) => select.id !== selectedId;
				if (dropdownEvent.target.value === 'Choose an option') {
					return;
				}
				[...formSelects]
					.filter(otherSelects)
					.filter(
						(fSelect, i) =>
							!(
								(isNotDefaultOption(fSelect.value) &&
									i === 0) ||
								(isNotDefaultOption(fSelect.value) && i > 0)
							)
					)
					.forEach((fSelect) => {
						const oldOptions = fSelect.innerHTML;
						fSelect.innerHTML = '';
						let cnt = 0;
						for (const item in items) {
							if (cnt === 0) {
								const firstOption = document.createElement(
									'option'
								);
								firstOption.innerHTML = 'Choose an option';
								fSelect.append(firstOption);
							}
							cnt++;
							if (
								items[item][fSelect.id] === '' ||
								isDefaultOption(dropdownEvent.target.value)
							) {
								fSelect.innerHTML = oldOptions;
								break;
							} else {
								const option = document.createElement('option');
								option.value = items[item][fSelect.id];
								option.innerHTML = krokedilFirstLetterUppercase(
									items[item][fSelect.id]
								);
								if (
									![...fSelect.options].some(
										(otherOption) =>
											otherOption.value === option.value
									)
								) {
									fSelect.append(option);
								}
							}
						}
					});
			};
			dropdown.name = names[nameIndex++];
			const chooseOption = document.createElement('option');
			chooseOption.innerHTML = 'Choose an option';
			dropdown.append(chooseOption);
			Object.values(variationAttributes.prod_attributes[key]).forEach(
				(objValue) => {
					const option = document.createElement('option');
					option.value = objValue;
					option.innerHTML = krokedilFirstLetterUppercase(objValue);
					dropdown.append(option);
				}
			);
			dropdownHolders[key] = dropdown;
		}
	}
	return dropdownHolders;
};

const reorder = (attributes, key) =>
	attributes.reduce((acc, cur) => {
		(acc[cur[key]] = acc[cur[key]] || []).push(cur);
		return acc;
	}, {});
